function updatePage(){
    let count = 0
    const timer = setInterval(()=> {
        let event = new Event('resize')
        window.dispatchEvent(event);
        count++
        if(count > 10) clearInterval(timer)
    }, 1000)
}

try {
    isReady('product-list', updatePage)
} catch (error) {
    console.log(error)
}